import {Injectable} from '@angular/core';
import {AppConstants} from '../shared/app.constants';
import {AuthService} from '../auth.service';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';

@Injectable()
export class AvailabiltyService {

  constructor(private appConstants: AppConstants, private auth: AuthService, private http: HttpClient) {
  }

  getAvailableDays(body): Observable<any> {
    const url = environment.apiBase + 'shifts/days_available/';
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.post(url, body, headers).map(response => response).catch(this.appConstants.errorHandler);
  }

  getAvailableFreelancers(body): Observable<any> {
    const url = environment.apiBase + 'bookings/availAdmin';
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.post(url, body, headers).map(response => response).catch(this.appConstants.errorHandler);
  }

}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/availabilities/availabilty.service.ts